import { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";

import Loading from "../../../components/Loading";
import Menu from "../../../components/Menu";

import api from "../../../services/api";

export const ControleTurma = () => {
    const [data, setData] = useState([]);
    const [initialDate, setInitialDate] = useState(new Date());

    const [isLoading, setIsLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const handleSubmit = () => {
        if(initialDate) {
            setIsLoading(true);

            let data_inicial = String(initialDate.getFullYear()) + '-' + String(initialDate.getMonth() + 1).padStart(2, '0') + '-' + String(initialDate.getDate()).padStart(2, '0');

            api.post('controle-turma', {
                "data_inicial": data_inicial
            }).then((response) => {
                fetchData();
                setIsLoading(false);
                showSuccess(response);
            }).catch((error) => {
                setData([]);
                setIsLoading(false);
                showError(error);
            });
        }
    }

    const fetchData = useCallback(() => {
        setIsLoading(true);
        api.get('controle-turma').then(response => {
            setData(response.data);
            setIsLoading(false);
        }).catch(error => {
            setData([]);
            setIsLoading(false);
        });
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    if(isLoading)
        return <Loading />

    return (
        <div>
            <Menu />
            <Toast ref={toast} />

            <Dialog
                header="Atualização"
                footer={() => (
                    <div>
                        <Button className="p-m-1 p-button-secondary" label="Cancelar" onClick={() => setIsVisible(false)} />
                        <Button className="p-m-1 p-button-success" label="Salvar" onClick={handleSubmit} />
                    </div>
                )}
                onHide={() => setIsVisible(false)}
                visible={isVisible}
            >
                <Calendar 
                    dateFormat="dd/mm/yy"
                    onChange={e => setInitialDate(e.value)}
                    placeholder="Data Inicial"
                    value={initialDate}
                />
            </Dialog>

            <Card className="p-m-1" title="Controle Turma">
                <Button 
                    className="p-m-1"
                    label="CLIQUE PARA ATUALIZAR DADOS CASO TENHA TIDO ALGUMA ATUALIZAÇÃO DE COLABORADOR, GRUPO OU TEAR"
                    onClick={() => setIsVisible(true)}
                    style={{ width: '100%' }}
                />
                <DataTable
                    emptyMessage="Nenhum registro encontrado."
                    responsiveLayout="scroll"
                    size="small"
                    value={data}
                >
                    <Column header="Tear" field="tear" sortable />
                    <Column header="Turma" field="turma" sortable />
                    <Column header="Grupo" field="grupo" sortable />
                    <Column header="Colaborador" field="colaborador" sortable />
                    <Column header="Data Inicial" field="datainicialf" sortable />
                </DataTable>
            </Card>
        </div>
    )
}